module.exports = __webpack_public_path__ + "img/icon-basket.bfbcd748.svg";